import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-3">
            <i className="ri-grid-line text-primary-500 mr-2"></i>
            热门大瓜分类索引
          </h2>
          <p className="text-sm text-foreground-600 text-center mb-10">
            按频道浏览，精准定位你感兴趣的今日大瓜
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3">
            {indexData.map((item) => (
              <a
                key={item.id}
                href="#index"
                className="group bg-background-50 rounded-lg p-4 text-center transition-all hover:bg-primary-50 cursor-pointer no-underline"
              >
                <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center rounded-full bg-primary-100 group-hover:bg-primary-200 transition-colors">
                  <i className={`${item.icon} text-lg text-primary-500`}></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-800 mb-1 whitespace-nowrap group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-1">
                  {item.desc}
                </p>
                <span className="text-xs text-accent-600 font-medium">
                  {item.count}条热瓜
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}